import { render, staticRenderFns } from "./edit-brand.vue?vue&type=template&id=4da0fc52&scoped=true&"
import script from "./edit-brand.vue?vue&type=script&lang=js&"
export * from "./edit-brand.vue?vue&type=script&lang=js&"
import style0 from "./edit-brand.vue?vue&type=style&index=0&id=4da0fc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0fc52",
  null
  
)

export default component.exports